/** Plain-words reason shown when a call ends or fails. */
export function endText(
  cause: string | undefined,
  kind: 'ended' | 'failed',
  direction: 'inbound' | 'outbound' | undefined,
  message?: unknown,
): string {
  if (kind === 'ended') return 'Call ended';
  const reason = String((message as { getHeader?: (n: string) => string } | undefined)?.getHeader?.('Reason') ?? '');
  switch (cause) {
    case 'Canceled':
      if (direction === 'inbound') {
        return /cause=200|elsewhere/i.test(reason) ? 'Answered on another device' : 'Missed call';
      }
      return 'Call cancelled';
    case 'Busy':
      return 'The line is busy';
    case 'Rejected':
      if (direction === 'inbound') return 'Call declined';
      // 403 = refused before reaching the other person (the carrier, or the server's number
      // rule - the app itself already refuses those numbers with a clear message), not declined
      if ((message as { status_code?: number } | undefined)?.status_code === 403) return 'The call couldn’t be connected';
      return 'Call declined by the other side';
    case 'Unavailable':
      return 'The number isn’t available right now';
    case 'Not Found':
      return 'Number not found';
    case 'Address Incomplete':
      return 'The number is incomplete';
    case 'Incompatible SDP':
    case 'Bad Media Description':
      return 'The call couldn’t set up audio';
    case 'No Answer':
      return 'No answer';
    case 'Request Timeout':
    case 'Connection Error':
      return 'Connection lost';
    case 'RTP Timeout':
      return 'Audio stopped arriving, so the call ended';
    case 'User Denied Media Access':
      return 'Microphone blocked';
    case 'Authentication Error':
      return 'Your line refused the call';
    case 'Unavailable Media':
      return 'Microphone unavailable';
    default:
      return cause ? `Call failed (${cause})` : 'Call failed';
  }
}
